<template>
  <modal type="text/x-template" id="ShoppingCartModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <img
                src="../assets/Close.svg"
                alt="Cerrar"
                width="30px"
                height="30px"
                @click="onClose()"
                class="close-ing"
              />
              <div class="container">
                <!-- <div class="products-headers">
                  <h5 class="prod-title title">Producto</h5>
                  <h5 class="title">Subtotal</h5>
                </div> -->
                <div class="container-items">
                  <CheckoutItem
                    v-for="(prod, index) in getSelectedProds"
                    :key="index"
                    :prod="prod"
                    :index="index"
                  />
                </div>
                <div class="total-headers">
                  <h5 class="prod-title title">Total (Sin envío)</h5>
                  <h5 class="title price">$ {{ getShoppingTotal }}</h5>
                </div>
              </div>

              <b-form-group
                id="input-group-1"
                label="Total del envío:"
                label-for="input-1"
                class="total-shipping"
              >
                <b-form-input
                  id="input-1"
                  type="number"
                  v-model="getShippingTotal"
                  placeholder="Total del envío"
                  @change="updateTotal($event)"
                ></b-form-input>
              </b-form-group>
              <ButtonComponent text="Finalizar compra" @onClick="onClick()" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import CheckoutItem from "./CheckoutItem";
import ButtonComponent from "./ButtonComponent";
import checkout_mixins from "../mixins/checkout_mixins";

export default {
  mixins: [checkout_mixins],
  name: "ShoppingCartModal",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    onClose() {
      this.$store.commit("SET_SHOW_SHOPPING_CART_MODAL", false);
    },
    onClick() {
      this.$router.replace("Checkout");
      this.$store.commit("SET_SHOW_SHOPPING_CART_MODAL", false);
    },
    updateTotal(evt) {
      this.$store.commit("SET_TOTAL_SHIPPING", evt);
    },
  },
  components: {
    CheckoutItem,
    ButtonComponent,
  },
};
</script>

<style scoped>
body {
  overflow-x: hidden;
  overflow-y: scroll !important;
}
.container-items {
  overflow-y: scroll;
  height: 50vh;
}
.close-ing {
  cursor: pointer;
}
.container {
  width: 100%;
}
.products-headers {
  display: inline-flex;
  width: 100%;
  margin: 15px 0px 15px 0px;
  border-bottom-style: solid;
  border-top-style: solid;
  border-color: darkgray;
  border-width: thin;
}
.total-headers {
  display: inline-flex;
  width: 100%;
  margin: 0px 0px 15px 0px;
  /* border-bottom-style: solid; */
  /* border-top-style: solid; */
  border-color: darkgray;
  border-width: thin;
  /* border-top-style: solid; */
  margin-top: 15px;
}
.total-shipping {
  margin: 0px 2vw 0px 2vw;
}
.prod-title {
  width: 75%;
}
.title {
  margin-top: 8px;
}
.price {
  text-align: end;
  width: 20%;
  font-size: 17px;
}

.header-container {
  display: inline-flex;
  margin-bottom: 2vh;
}
.header-title {
  margin-left: 5px;
  margin-top: 7px;
  font-size: initial;
}
.filter-content {
  /* background: rgba(95, 106, 121, 0.06); */
  align-self: center;
}

.modal-xs-header-text.modal-xs-right-header-text {
  margin-left: 30px;
}
.modal-xs-header-text {
  display: inline-block;
  clear: both;
  font-size: 16px;
  text-transform: uppercase;
}
.modal-xs-header {
  color: #5f6a79;
  fill: #5f6a79;
}
.modal-xs-header {
  position: relative;
  display: block;
  padding: 15px;
  clear: both;
  text-decoration: none;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.modal-xs-header-icon.modal-xs-right-header-icon {
  left: 5px;
  right: initial;
}
.modal-xs-header-icon {
  position: absolute;
  top: 11px;
  right: 14px;
}

svg:not(:root) {
  overflow: hidden;
}
.fa-2x {
  font-size: 2em;
}
.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.header {
  width: 90%;
  margin-left: 10%;
  padding: 10px;
}

.modal-footer {
  display: inherit;
}

.produts-title {
  text-align: center;
  font-weight: bold;
}
.title {
  font-weight: 800;
}
.close-modal {
  width: 10%;
  text-align: end;
}
.button-close {
  background: red;
  border-radius: 20px;
  padding: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 30%;
  float: right;
  height: 100%;
  margin: 0px auto;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  min-width: -webkit-fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
  overflow-y: auto;
}

.modal-header {
  margin-top: 0;
  color: #212529;
  text-align: center;
  justify-content: center;
  align-self: center;
}
.container-button {
  padding: 15px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
h5 {
  font-size: 15px;
}
@media only screen and (max-width: 743px) {
  .modal-container {
    width: 100%;
  }
  .price {
    width: 25%;
  }
  .title {
    width: 75%;
  }
}
@media only screen and (min-height: 900px) {
  .container-items {
    height: 65vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingCartModal.vue